import {ChangeDetectorRef, Component} from "@angular/core";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {InventoryCustomObjectTypeEntityModel} from "../inventory-custom-object-type-entity.model";
import {CustomObjectTypeEditPageComponent} from "./custom-object-type-edit-page.component";
import {InventoryCustomObjectEditPageComponent} from "../../custom-object/custom-object-edit-page/inventory-custom-object-edit-page.component";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-inventory-custom-object-type-edit-page",
    templateUrl: "./custom-object-type-edit-page.component.html",
    providers: [provideEntityModel(InventoryCustomObjectTypeEntityModel)]
})
export class InventoryCustomObjectTypeEditPageComponent extends CustomObjectTypeEditPageComponent {
    override CustomObjectEditPageComponent = InventoryCustomObjectEditPageComponent;
    override fixedType: boolean = true;

    constructor(model: InventoryCustomObjectTypeEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(model, changeDetectorRef, responsiveService);
    }
}
